import PenV2 from "../Assets/SVGs/PenV2";
import LinkEx from "../Assets/SVGs/linkEx";
import CheckBox from "../Assets/SVGs/Check";
import TrashV2 from "../Assets/SVGs/TrashV2";
import InfoIcon from "@material-ui/icons/Info";
import MenuIcon from "@material-ui/icons/Menu";
import LoopIcon from "@material-ui/icons/Loop";
import SortIcon from "@material-ui/icons/Sort";
import RoomIcon from "@material-ui/icons/Room";
import DrawItem from "../Assets/SVGs/DrawItem";
import MultiBox from "../Assets/SVGs/multiBox";
import UncheckBox from "../Assets/SVGs/Uncheck";
import ChangeSeq from "../Assets/SVGs/changeSeq";
import EventIcon from "@material-ui/icons/Event";
import BuildIcon from "@material-ui/icons/Build";
import GroupIcon from "@material-ui/icons/Group";
import CloseIcon from "@material-ui/icons/Close";
import SpeedIcon from "@material-ui/icons/Speed";
import MemoryIcon from "@material-ui/icons/Memory";
import SearchIcon from "@material-ui/icons/Search";
import PersonIcon from "@material-ui/icons/Person";
import PublicIcon from "@material-ui/icons/Public";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import FolderIcon from "@material-ui/icons/Folder";
import GetAppIcon from "@material-ui/icons/GetApp";
import NoDataIcon from "../Assets/SVGs/noDataIcon";
import PacketIcon from "../Assets/SVGs/PacketIcon";
import WeightIcon from "../Assets/SVGs/WeightIcon";
import VolumeIcon from "../Assets/SVGs/VolumeIcon";
import PickUpIcon from "../Assets/SVGs/PickUpIcon";
import MapWithPin from "../Assets/SVGs/mapWithPin";
import RemoveIcon from "@material-ui/icons/Remove";
import PaymentIcon from '@material-ui/icons/Payment';
import WifiOffIcon from "@material-ui/icons/WifiOff";
import PostAddIcon from '@material-ui/icons/PostAdd';
import PolygonIcon from "../Assets/SVGs/PolygonIcon";
import PinDropIcon from "@material-ui/icons/PinDrop";
import ListAltIcon from "@material-ui/icons/ListAlt";
import Visibility from "@material-ui/icons/Visibility";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import LanguageIcon from '@material-ui/icons/Language';
import SettingsIcon from "@material-ui/icons/Settings";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import ChangeStatus from "../Assets/SVGs/ChangeStatus";
import SwapCallsIcon from "@material-ui/icons/SwapCalls";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import AssessmentIcon from "@material-ui/icons/Assessment";
import PolygonPinIcon from "../Assets/SVGs/PolygonPinIcon";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import FilterListIcon from "@material-ui/icons/FilterList";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import AssignmentIcon from "@material-ui/icons/Assignment";
import MapTwoToneIcon from "@material-ui/icons/MapTwoTone";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import ActualRouteIcon from "../Assets/SVGs/actualRouteIcon";
import LowPriorityIcon from "@material-ui/icons/LowPriority";
import LocationOffIcon from "@material-ui/icons/LocationOff";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DescriptionIcon from "@material-ui/icons/Description";
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import DownloadExcelFile from "../Assets/SVGs/DownloadExcel";
import SystemUpdateIcon from '@material-ui/icons/SystemUpdate';
import ActualDeliveryIcon from "../Assets/SVGs/actualDelivery";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import EditLocationIcon from "@material-ui/icons/EditLocation";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import OndemandVideoIcon from "@material-ui/icons/OndemandVideo";
import PhonelinkEraseIcon from "@material-ui/icons/PhonelinkErase";
import ArrowRightAltIcon from "@material-ui/icons/CallMadeRounded";
import PersonAddDisabled from "@material-ui/icons/PersonAddDisabled";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import LibraryAddCheckIcon from "@material-ui/icons/LibraryAddCheck";
import PersonAddRoundedIcon from "@material-ui/icons/PersonAddRounded";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import Battery80RoundedIcon from "@material-ui/icons/Battery80Rounded";
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import SignalCellularOffIcon from "@material-ui/icons/SignalCellularOff";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import NotListedLocationIcon from "@material-ui/icons/NotListedLocation";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import SignalCellular4BarIcon from "@material-ui/icons/SignalCellular4Bar";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import PhoneEnabledRoundedIcon from "@material-ui/icons/PhoneEnabledRounded";
import QueryBuilderRoundedIcon from "@material-ui/icons/QueryBuilderRounded";
import LocalShippingRoundedIcon from "@material-ui/icons/LocalShippingRounded";
import WarehouseToFirstLocation from "../Assets/SVGs/WarehouseToFirstLocation";
import SignalCellularConnectedNoInternet2BarIcon from "@material-ui/icons/SignalCellular2Bar";
import SignalCellularConnectedNoInternet0BarIcon from "@material-ui/icons/SignalCellularConnectedNoInternet0Bar";
import History from "../Assets/SVGs/history";
import LaunchMode from "../Assets/SVGs/launchMode";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import SmsIcon from "@material-ui/icons/Sms";
import HowToRegIcon from "@material-ui/icons/HowToReg";

export const iconsMap = {
  pen2: (style) => <PenV2 style={style} />,
  pin: (style) => <RoomIcon style={style} />,
  linkEx: (style) => <LinkEx style={style} />,
  info: (style) => <InfoIcon style={style} />,
  menu: (style) => <MenuIcon style={style} />,
  loop: (style) => <LoopIcon style={style} />,
  sort: (style) => <SortIcon style={style} />,
  trash2: (style) => <TrashV2 style={style} />,
  pen: (style) => <CreateIcon style={style} />,
  tool: (style) => <BuildIcon style={style} />,
  history: (style) => <History style={style} />,
  users: (style) => <GroupIcon style={style} />,
  close: (style) => <CloseIcon style={style} />,
  speed: (style) => <SpeedIcon style={style} />,
  user: (style) => <PersonIcon style={style} />,
  chip: (style) => <MemoryIcon style={style} />,
  trash: (style) => <DeleteIcon style={style} />,
  list: (style) => <ListAltIcon style={style} />,
  checkBox: (style) => <CheckBox style={style} />,
  packet: (style) => <PacketIcon style={style} />,
  weight: (style) => <WeightIcon style={style} />,
  volume: (style) => <VolumeIcon style={style} />,
  PickUp: (style) => <PickUpIcon style={style} />,
  noData: (style) => <NoDataIcon style={style} />,
  search: (style) => <SearchIcon style={style} />,
  excel: (style) => <PostAddIcon style={style} />,
  public: (style) => <PublicIcon style={style} />,
  lock: (style) => <LockOpenIcon style={style} />,
  folder: (style) => <FolderIcon style={style} />,
  multiBox: (style) => <MultiBox style={style} />,
  DrawIcon: (style) => <DrawItem style={style} />,
  add: (style) => <AddRoundedIcon style={style} />,
  map: (style) => <MapTwoToneIcon style={style} />,
  calendar: (style) => <EventIcon style={style} />,
  earth: (style) => <LanguageIcon style={style} />,
  task: (style) => <AssignmentIcon style={style} />,
  polygon: (style) => <PolygonIcon style={style} />,
  pinDrop: (style) => <PinDropIcon style={style} />,
  download: (style) => <GetAppIcon style={style} />,
  lineIcon: (style) => <RemoveIcon style={style} />,
  bike: (style) => <MotorcycleIcon style={style} />,
  offline: (style) => <WifiOffIcon style={style} />,
  payment: (style) => <PaymentIcon style={style} />,
  home: (style) => <HomeRoundedIcon style={style} />,
  watch: (style) => <WatchLaterIcon style={style} />,
  setting: (style) => <SettingsIcon style={style} />,
  ToDo: (style) => <LowPriorityIcon style={style} />,
  mapWithPin: (style) => <MapWithPin style={style} />,
  launchMode: (style) => <LaunchMode style={style} />,
  visibility: (style) => <Visibility style={style} />,
  uncheckBox: (style) => <UncheckBox style={style} />,
  merge: (style) => <AccountTreeIcon style={style} />,
  openMenu: (style) => <MenuOpenIcon style={style} />,
  filter: (style) => <FilterListIcon style={style} />,
  view: (style) => <RemoveRedEyeIcon style={style} />,
  car: (style) => <DirectionsCarIcon style={style} />,
  changeReseq: (style) => <ChangeSeq style={style} />,
  distance: (style) => <SwapCallsIcon style={style} />,
  pinOff: (style) => <LocationOffIcon style={style} />,
  goToPage: (style) => <OpenInNewIcon style={style} />,
  check: (style) => <CheckRoundedIcon style={style} />,
  tracking: (style) => <ActualRouteIcon style={style} />,
  analytics: (style) => <AssessmentIcon style={style} />,
  chevLeft: (style) => <ChevronLeftIcon style={style} />,
  noUser: (style) => <PersonAddDisabled style={style} />,
  changeStatus: (style) => <ChangeStatus style={style} />,
  polygonPin: (style) => <PolygonPinIcon style={style} />,
  createPoly: (style) => <AddToPhotosIcon style={style} />,
  remainPin: (style) => <EditLocationIcon style={style} />,
  drawerIcon: (style) => <DoubleArrowIcon style={style} />,
  power: (style) => <PowerSettingsNewIcon style={style} />,
  chevRight: (style) => <ChevronRightIcon style={style} />,
  visibilityOff: (style) => <VisibilityOff style={style} />,
  liveTrack: (style) => <OndemandVideoIcon style={style} />,
  upArrow: (style) => <KeyboardArrowUpIcon style={style} />,
  description: (style) => <DescriptionIcon style={style} />,
  circle: (style) => <FiberManualRecordIcon style={style} />,
  notmet: (style) => <NotListedLocationIcon style={style} />,
  table: (style) => <FormatListBulletedIcon style={style} />,
  battery: (style) => <Battery80RoundedIcon style={style} />,
  phone: (style) => <PhoneEnabledRoundedIcon style={style} />,
  clock: (style) => <QueryBuilderRoundedIcon style={style} />,
  truck: (style) => <LocalShippingRoundedIcon style={style} />,
  upload: (style) => <CloudUploadOutlinedIcon style={style} />,
  addPerson: (style) => <PersonAddRoundedIcon style={style} />,
  DownloadExcel: (style) => <DownloadExcelFile style={style} />,
  DownloadForm: (style) => <SystemUpdateIcon style={style} />,
  multiSelect: (style) => <LibraryAddCheckIcon style={style} />,
  deCluster: (style) => <SignalCellularOffIcon style={style} />,
  downArrow: (style) => <KeyboardArrowDownIcon style={style} />,
  ActualDelivery: (style) => <ActualDeliveryIcon style={style} />,
  trashRestore: (style) => <RestoreFromTrashIcon style={style} />,
  goodSignal: (style) => <SignalCellular4BarIcon style={style} />,
  driverActivation: (style) => <PhoneAndroidIcon style={style} />,
  WareToLoc: (style) => <WarehouseToFirstLocation style={style} />,
  driverDeActivation: (style) => <PhonelinkEraseIcon style={style} />,
  weakSignal: (style) => (
    <SignalCellularConnectedNoInternet0BarIcon style={style} />
  ),
  normalSignal: (style) => (
    <SignalCellularConnectedNoInternet2BarIcon style={style} />
  ),
  arrowRight: (style) => (
    <ArrowRightAltIcon
      style={{
        transform: "rotate(45deg)",
        ...style,
      }}
    />
  ),
  arrowLeft: (style) => (
    <ArrowRightAltIcon
      style={{
        transform: "rotate(225deg)",
        ...style,
      }}
    />
  ),
    optimzieDashboard: (style) => (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            style={{margin:"5px 0"}}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 16V21M18 21L14.0486 17.7072C13.3198 17.0998 12.9554 16.7962 12.5487 16.6801C12.19 16.5778 11.81 16.5778 11.4513 16.6801C11.0446 16.7962 10.6802 17.0998 9.95141 17.7072L6 21M8 11V12M12 9V12M16 7V12M22 3H2M3 3H21V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3Z"
                stroke={"white"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
  downloadReport : (props) => {return (<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M5.75 1a.75.75 0 0 1 .75.75V3.6l1.72-.344a8.7 8.7 0 0 1 4.925.452l.413.165a7.3 7.3 0 0 0 4.482.304a.73.73 0 0 1 .803 1.084l-1.278 2.131c-.342.57-.513.854-.553 1.163q-.025.195 0 .39c.04.309.211.594.553 1.163l1.56 2.6a.9.9 0 0 1-.553 1.336l-.1.025a8.68 8.68 0 0 1-5.327-.361a8.7 8.7 0 0 0-4.924-.452L6.5 13.6v8.15a.75.75 0 0 1-1.5 0v-20A.75.75 0 0 1 5.75 1"></path></svg>)},
  disabled: () =><NotInterestedIcon/>,
  sms: (style) => <SmsIcon style={style} />,
  assignDrivers: (style) => <HowToRegIcon style={style} />,
};